export enum MoveActionEnum {
    TOP = 'TOP',
    UP = 'UP',
    DOWN = 'DOWN',
    BOTTOM = 'BOTTOM',
}
